import React, { useEffect, useState, useRef } from 'react';
import { PageButtonIcon, PageButtonNumber, Container, ThisCard, ScrollOS } from './styles';
import * as XLSX from 'xlsx';

import { store } from "~/store";
import { loadingToggle } from "~/store/modules/loadingModal/actions";

import { renderToString } from "react-dom/server";
import { jsPDF } from 'jspdf';

import IconProjeto from '~/assets/icones/IconProjeto.svg';
import IconExcel from "~/assets/icones/IconExcel.svg";
import IconExcelB from "~/assets/icones/IconExcelB.svg";
import IconPdf from "~/assets/icones/IconePdf.svg";
import IconPdfB from "~/assets/icones/IconePdfB.svg";
import OsTemplate from './Template/OsTemplate';
import NunitoSemiBold from '~/utils/Nunito-semiBold.js';

import { Input, Select } from "~/componentes/CustomForm";
import api from "~/services/api";

function CustomBodyContent({
  data,
  previsaoInicio,
  setPrevisaoInicio,
  previsaoFinal,
  setPrevisaoFinal,
  idCliente,
  setIdCliente,
  statusAprovacao,
  setStatusAprovacao,
  idProjeto,
  setIdProjeto,
}) {
  const dispatch = store.dispatch;
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [pagAtiva, setPagAtiva] = useState(0);
  const [geraExcel, setGeraExcel] = useState(false);
  const [geraPdf, setGeraPdf] = useState(false);
  const sizePage = 10;
  const pdfRef = useRef(null);

  const [clientes, setClientes] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [projetos, setProjetos] = useState([]);

  const dataDe = previsaoInicio.getFullYear() + "-" + ((previsaoInicio.getMonth() + 1) > 9 ? (previsaoInicio.getMonth() + 1) : "0" + (previsaoInicio.getMonth() + 1)) + "-" + ((previsaoInicio.getDate() + 1) > 9 ? (previsaoInicio.getDate()) : "0" + (previsaoInicio.getDate()));
  const dataAte = previsaoFinal.getFullYear() + "-" + ((previsaoFinal.getMonth() + 1) > 9 ? (previsaoFinal.getMonth() + 1) : "0" + (previsaoFinal.getMonth() + 1)) + "-" + ((previsaoFinal.getDate() + 1) > 9 ? (previsaoFinal.getDate()) : "0" + (previsaoFinal.getDate()));

  const handleDownload = async () => {
    dispatch(loadingToggle());

    let htmlElement = <OsTemplate data={dataPage} />;
    let elementAsString = renderToString(htmlElement);

    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: 'p'
    });
    doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
    doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
    doc.setFont('Nunito');

    doc.setFontSize(10);
    doc.html(elementAsString, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
        dispatch(loadingToggle());
      },
    });
  };

  function addPagination(pag, maxPag) {
    // Cria o html do item da paginação
    const identificaAtivo = (paginaAtual, paginaAdd, points) => {
      if (!points) {
        return <PageButtonNumber
          type="button"
          onClick={() => setPagAtiva(paginaAdd - 1)}
          key={paginaAdd}
          ativo={paginaAtual === paginaAdd ? 1 : undefined}
          numberdigits={paginaAdd}
        >
          <span />
          <p>{paginaAdd}</p>
        </PageButtonNumber>;
      } else {
        return <PageButtonNumber type="button">...</PageButtonNumber>;
      }
    };

    let itens = [];
    if (pag > 0) {
      if (maxPag === 0) {
        // html += identificaAtivo(0, 1);
      } else if (pag <= 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (var count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else if (pag <= maxPag - 3) {
        itens.push(identificaAtivo(pag, 1));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, pag - 2));
        itens.push(identificaAtivo(pag, pag - 1));
        itens.push(identificaAtivo(pag, pag));
        itens.push(identificaAtivo(pag, pag + 1));
        itens.push(identificaAtivo(pag, pag + 2));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, maxPag));
      } else if (pag > maxPag - 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (let count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else {
        itens.push(identificaAtivo(0, 1));
      }
    }
    return itens;
  }

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/relatorios/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/relatorios/projetos", { params: { ativo: 1, ...(idCliente ? { idCliente } : {}) } })
      .then(response => setProjetos(response.data));
  }, [idCliente]);

  useEffect(() => {
    if (data && data?.length > 0) {
      let dados = [[]];
      let page = 0;
      let count = 0;

      for (const item of data) {
        dados[page].push(item);

        if (sizePage == (count + 1)) {
          dados.push([]);

          count = 0;
          page++;
        }

        count++;
      }

      setPagAtiva(0);
      setDataPage(dados);
    } else {
      setPagAtiva(0);
      setDataPage([]);
    }
  }, [data]);

  useEffect(() => {
    if (data && data?.length > 0) {
      let dados = [];
      dispatch(loadingToggle());

      for (const item of data) {
        dados.push({
          "Id OS": item?.id,
          "Emissão": ((new Date(item?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
          "Titulo": item?.titulo,
          "Analista": item?.analista?.nome,
          "Etapa": item?.descricaoStatusAprov,
          "Apontada": item?.horaApontadaMascara,
          "Desconto": item?.horaDescontoMascara,
          "Translado": item?.horaTransladoMascara,
          "Total": item?.horaTotalMascara,
          "Projeto": item?.projeto?.titulo,
          "Cliente": item?.cliente?.nomeFantasia,
          "Aprovador 1": item?.coordenador?.nome,
          "Aprovador 2": item?.coordenadorTec?.nome,
        });
      }

      const worksheet = XLSX.utils.json_to_sheet(dados);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ordem Servico");
      XLSX.writeFile(workbook, "Ordem Servico" + (new Date().toLocaleString('pt-BR', { timeZone: 'UTC' })) + ".xlsx");

      dispatch(loadingToggle());
    }
  }, [geraExcel]);

  useEffect(() => {
    if (geraPdf) {
      handleDownload();
      setGeraPdf(false);
    }
  }, [geraPdf]);

  return (
    <Container>
      <div className='content-os'>
        <div className='header'>
          <div className='titulo'>
            <img src={IconProjeto} alt={"IconOrdem"} />
            <h4 className="title">Ordem de Serviço</h4>
          </div>
          <div className="div-right">
            <button className="btn-excel" onClick={() => setGeraExcel(true)}>
              <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
            </button>
            <button className="btn-pdf" onClick={() => setGeraPdf(true)}>
              <img src={localStorage.getItem("tema") == "E" ? IconPdf : IconPdfB} alt="Icone de Pdf" />
            </button>
            <div className="pagination">
              <PageButtonIcon
                type="button"
                onClick={() => pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva)}
                className="material-icons"
              >
                navigate_before
              </PageButtonIcon>
              <div className="pag-number">
                {addPagination(pagAtiva + 1, dataPage?.length)}
              </div>
              <PageButtonIcon
                type="button"
                onClick={() => { pagAtiva < (dataPage?.length - 1) ? setPagAtiva(pagAtiva + 1) : setPagAtiva(pagAtiva) }}
                className=" material-icons"
              >
                navigate_next
              </PageButtonIcon>
            </div>
          </div>
        </div>
        <div className='filtro'>
          <div className='item'>
            <Select
              isString
              list={{ list: clientes, value: "id", label: "nomeFantasia" }}
              name="idCliente"
              firstOption="Todos Clientes"
              defaultValue={idCliente}
              onChange={(e) => {
                const v = e.currentTarget.value || null;
                setIdCliente(v);
              }}
            />
          </div>
          <div className='item'>
            <Select
              isString
              list={{ list: projetos, value: "id", label: "titulo" }}
              name="idProjeto"
              defaultValue={idProjeto}
              firstOption="Todas Projetos"
              onChange={(e) => {
                const v = e.currentTarget.value || null;
                setIdProjeto(v);
              }}
            />
          </div>
          <div className='item'>
            <Input
              name="dataDe"
              type="date"
              defaultValue={dataDe}
              onBlur={(e) => {
                const v = e.currentTarget.value || "";
                setPrevisaoInicio(new Date(v + " 03:00:00"));
              }}
            />
          </div>
          <div className='item'>
            <Input
              name="dataAte"
              type="date"
              defaultValue={dataAte}
              onChange={(e) => {
                const v = e.currentTarget.value || "";
                setPrevisaoFinal(new Date(v + " 03:00:00"));
              }}
            />
          </div>
          <div className='item'>
            <Select
              isString
              list={{
                list: [
                  { id: "-", titulo: "Todos Status" },
                  { id: "A", titulo: "Aguard. Aprovação Coord" },
                  { id: "C", titulo: "Aguard. Aprovação Tec" },
                  { id: "T", titulo: "Aguard. Encerramento" },
                  { id: "R", titulo: "Reprovado Coordenador" },
                  { id: "S", titulo: "Reprovado Tecnico" },
                  { id: "E", titulo: "Encerrada" },
                ],
                value: "id",
                label: "titulo"
              }}
              name="statusAprovacao"
              defaultValue={statusAprovacao}
              onChange={(e) => {
                const v = e.currentTarget.value || "-";
                setStatusAprovacao(v);
              }}
            />
          </div>
        </div>
        <ScrollOS className='body'>
          <div className="display-oc" ref={pdfRef}>
            <ThisCard
              className="card-header"
              {...{ linhaAtiva, setLinhaAtiva }}
              ativo={false}
            >
              <div className="row">
                <div className="col w1">
                  <div className="card-cod">
                    <p className="cod">Id</p>
                  </div>
                </div>
                <div className="col w1">
                  <p>Emissão</p>
                </div>
                <div className="col w3">
                  <p>Título</p>
                </div>
                <div className="col w3">
                  <p>Analista</p>
                </div>
                <div className="col w2">
                  <p>Etapa</p>
                </div>
                <div className="col w1 center">
                  <p>Apontada</p>
                </div>
                <div className="col w1 center">
                  <p>Desconto</p>
                </div>
                <div className="col w1 center">
                  <p>Translado</p>
                </div>
                <div className="col w1 center">
                  <p>Total</p>
                </div>
                <div className="col w3">
                  <p>Projeto</p>
                </div>
                <div className="col w2">
                  <p>Cliente</p>
                </div>
                <div className="col w2">
                  <p>Aprovador 1</p>
                </div>
                <div className="col w2">
                  <p>Aprovador 2</p>
                </div>
              </div>
            </ThisCard>
            {dataPage[pagAtiva]?.map((thisProjeto, i) => (
              <ThisCard
                className={
                  linhaAtiva === thisProjeto?.id ? 'card-item ativo' : 'card-item'
                }
                {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
                key={thisProjeto?.id || i}
                id={thisProjeto?.id || i}
                index={i}
                ativo={linhaAtiva === thisProjeto?.id ? true : false}
              >
                <div className="row">
                  <div className="col w1">
                    <div className="card-cod">
                      <p className="cod">#{thisProjeto?.id}</p>
                    </div>
                  </div>
                  <div className="col w1">
                    <p>{((new Date(thisProjeto?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.titulo}</p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.analista?.nome}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.descricaoStatusAprov}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{thisProjeto?.horaApontadaMascara}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{thisProjeto?.horaDescontoMascara}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{thisProjeto?.horaTransladoMascara}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{thisProjeto?.horaTotalMascara}</p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.projeto?.titulo}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.cliente?.nomeFantasia}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.coordenador?.nome}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.coordenadorTec?.nome}</p>
                  </div>
                </div>
              </ThisCard>
            ))}
          </div>
        </ScrollOS>
      </div>
    </Container>
  );
  // return (
  //   <Container>
  //     <div className="content-oc">
  //       <SectionProjeto height={"22em"}>
  //         <div className="header">
  //           <div className="div-icone">
  //             <img src={IconProjeto} alt={"IconProjeto"} />
  //             <h4 className="title">Ordem de Serviço</h4>
  //           </div>
  //           <div className="div-right">
  //             <button className="btn-excel" onClick={() => setGeraExcel(true)}>
  //               <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
  //             </button>
  //             <button className="btn-pdf" onClick={() => setGeraPdf(true)}>
  //               <img src={localStorage.getItem("tema") == "E" ? IconPdf : IconPdfB} alt="Icone de Pdf" />
  //             </button>
  //             <div className="pagination">
  //               <PageButtonIcon
  //                 type="button"
  //                 onClick={() => pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva)}
  //                 className="material-icons"
  //               >
  //                 navigate_before
  //               </PageButtonIcon>
  //               <div className="pag-number">
  //                 {addPagination(pagAtiva + 1, dataPage?.length)}
  //               </div>
  //               <PageButtonIcon
  //                 type="button"
  //                 onClick={() => { pagAtiva < (dataPage?.length - 1) ? setPagAtiva(pagAtiva + 1) : setPagAtiva(pagAtiva) }}
  //                 className=" material-icons"
  //               >
  //                 navigate_next
  //               </PageButtonIcon>
  //             </div>
  //           </div>
  //         </div>
  //         <ScrollOS>
  //           <div className="display-oc" ref={pdfRef}>
  //             <ThisCard
  //               className="card-header"
  //               {...{ linhaAtiva, setLinhaAtiva }}
  //               ativo={false}
  //             >
  //               <div className="row">
  //                 <div className="col w1">
  //                   <div className="card-cod">
  //                     <p className="cod">Id</p>
  //                   </div>
  //                 </div>
  //                 <div className="col w1">
  //                   <p>Emissão</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Título</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Analista</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Etapa</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Apontada</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Desconto</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Translado</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Total</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Projeto</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Cliente</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Aprovador 1</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Aprovador 2</p>
  //                 </div>
  //               </div>
  //             </ThisCard>
  //             {dataPage[pagAtiva]?.map((thisProjeto, i) => (
  //               <ThisCard
  //                 className={
  //                   linhaAtiva === thisProjeto?.id ? 'card-item ativo' : 'card-item'
  //                 }
  //                 {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
  //                 key={thisProjeto?.id || i}
  //                 id={thisProjeto?.id || i}
  //                 index={i}
  //                 ativo={linhaAtiva === thisProjeto?.id ? true : false}
  //               >
  //                 <div className="row">
  //                   <div className="col w1">
  //                     <div className="card-cod">
  //                       <p className="cod">#{thisProjeto?.id}</p>
  //                     </div>
  //                   </div>
  //                   <div className="col w1">
  //                     <p>{((new Date(thisProjeto?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.titulo}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.analista?.nome}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.descricaoStatusAprov}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaApontadaMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaDescontoMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaTransladoMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaTotalMascara}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.projeto?.titulo}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.cliente?.nomeFantasia}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.coordenador?.nome}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.coordenadorTec?.nome}</p>
  //                   </div>
  //                 </div>
  //               </ThisCard>
  //             ))}
  //           </div>
  //         </ScrollOS>
  //       </SectionProjeto>
  //     </div>
  //   </Container>
  // );
}

export default CustomBodyContent;
